import { render, staticRenderFns } from "./StudentStaffDocuments.vue?vue&type=template&id=f9cd651a&"
import script from "./StudentStaffDocuments.vue?vue&type=script&lang=js&"
export * from "./StudentStaffDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports